import { Grid } from "@material-ui/core"
import styled from "styled-components"

export const ContainerItemGrid = styled(Grid).attrs({
    container: true,
    item: true,
})``
export const ContainerGrid = styled(Grid).attrs({
    container: true,
})``
export const ItemGrid = styled(Grid).attrs({
    item: true,
})``

